import Cache from 'lib/cache';

class StartupCustomerFilters {

  constructor(startupBasePath, currentUserBasePath, apiClient) {

    this.startupBasePath = `${startupBasePath}/customer-filters`;
    this.userBasePath = `${currentUserBasePath}/customer-filters`;
    this.apiClient = apiClient;

    this.cache = new Cache(null, null);

  }

  async createCustomerFilter(customerFilter) {

    const path = this.userBasePath;

    this.cache.reset();

    return this.apiClient.post(path, {}, {}, customerFilter);

  }

  async getCustomerFilters(projection) {

    const path = this.startupBasePath;

    if (this.cache.isAvailable() === true) {
      return this.cache.getData();
    }

    const filters = await this.apiClient.get(path, {}, { projection });

    this.cache.setData(filters);

    return filters;

  }

  async getCustomerFilterById(customerFilterId) {

    const path = `${this.userBasePath}/:customerFilterId`;

    this.cache.reset();

    return this.apiClient.get(path, { customerFilterId }, {});

  }

  async updateCustomerFilterByCustomerFilterId(customerFilterId, customerFilter) {

    const path = `${this.userBasePath}/:customerFilterId`;

    this.cache.reset();

    return this.apiClient.put(path, { customerFilterId }, {}, customerFilter);

  }

  async deleteCustomerFilterByCustomerFilterId(customerFilterId) {

    const path = `${this.userBasePath}/:customerFilterId`;

    this.cache.reset();

    return this.apiClient.delete(path, { customerFilterId }, {});

  }

}

export default StartupCustomerFilters;